var angular = require('angular');
var _module = require('../module');
//var res = require('./test-results');
var _ = require('lodash');
var $ = require('jquery');
var simpleCypher = require('../../../libs/simple-cypher');


require('../../filters');
require('../../services/user');
require('../../services/search');
require('../../services/search-filter');
require('../../services/address-deduplication');
require('../../services/search-results-utils');
require('../../services/first-filter-modal');
require('../../services/lr-touch');
require('../../services/login-or-register-modal');
require('../../services/listhub');
require('../../services/get-alerts-modal');
require('../../services/utils');
require('../../services/analytics');
require('./search-controls');
require('./map-results');
require('../mobile-alerts-banner');
require('angular-input-masks');
require('../third-party/angular-click-outside');
require('../third-party/angular-preload-image');
require('../google-search-autocomplete');
require('../pageit');
require('../listing-card');
require('../../services/mls-accept-toc');

_module.requires.push('ui.utils.masks', 'angular-preload-image', 'angular-click-outside');

_module.component('searchResults', {
    controllerAs: 'searchResults',
    controller: [
        '$log',
        '$window',
        '$scope',
        '$filter',
        '$search',
        '$state',
        '$stateParams',
        '$user',
        '$firstFilterModal',
        'srUtils',
        'SearchFilter',
        'localStorageService',
        '$loginOrRegisterModal',
        '$getAlertsModal',
        '$timeout',
        '$listhub',
        '$q',
        '$rootScope',
        '$utils',
        '$location',
        'addressDeduplicationService',
        'Search',
        '$mlsAcceptToC',

        function searchResultsCtrl($log, $window, $scope, $filter, $search, $state, $stateParams, $user, $firstFilterModal, srUtils, SearchFilter, localStorageService, $loginOrRegisterModal, $getAlertsModal, $timeout, $listhub, $q, $rootScope, $utils, $location, addressDeduplicationService, Search, $mlsAcceptToC) {
            $log.debug('Search Results Page', this);

            var vm = this;
            vm.model = {
                loadingListings: false,
                switchingFilters: false,
                pageData: undefined,
                listingsSource: $user.currentSearch ? 'search' : 'filter'
            };
            vm.services = {
                getPaginatedResults: getPaginatedResults,
                switchCurrentView: switchCurrentView,
                mobileSortListByUpdated: mobileSortListByUpdated,
                sortListByUpdated: sortListByUpdated,
                updateFilterData: updateFilterData,
                switchCurrentFilter: switchCurrentFilter,
                shouldShowSortByDomOption: shouldShowSortByDomOption,
                searchSubmit: searchSubmit,
                getCurrentFilterId: getCurrentFilterId,
                updateUserCurrentState: updateUserCurrentState
            };


            // Service Functions
            function getPaginatedResults(page) {
                if(vm.model.loadingListings || !($user.currentFilter || vm.model.listingsSource === 'search')) return;

                var currentObj = vm.model.listingsSource === 'search' && $user.currentSearch ? $user.currentSearch : $user.currentFilter;

                if(!currentObj) {
                    _.set(vm, 'ui.exceptions.noFilters', true);
                    vm.model.switchingFilters = false;
                    return;
                } else {
                    _.set(vm, 'ui.exceptions.noFilters', false);
                }

                vm.model.loadingListings = true;
                var promise;
                var limit = 50;

                // if we're trying to load a different page from the on that's
                // current saved in usrCurrState, we reset the scrollTop to 0
                if(vm.model.pageData && vm.model.pageData.page && vm.model.pageData.page !== page) {
                    updateUserCurrentState('listViewScrollTop', 0);
                }

                if(
                    currentObj &&
                    currentObj._pageData &&
                    currentObj._pageData.page === page &&
                    currentObj._pageData.orderby === vm.sortListBy.selected.value &&
                    !vm.model.switchingFilters &&
                    !$stateParams.reloadData
                ) {
                    promise = $q.when({
                        listings: currentObj._pageData.data,
                        total: currentObj._pageData.total
                    });

                    if($stateParams.reloadDataInBackground) {
                        currentObj.getListings({
                            limit: limit,
                            page: page,
                            orderby: vm.sortListBy.selected.value,
                            bypasscache: $stateParams.bypassCache
                        });
                    }
                } else {
                    promise = currentObj.getListings({
                        limit: limit,
                        page: page,
                        orderby: vm.sortListBy.selected.value,
                        bypasscache: $stateParams.bypassCache
                    });
                }

                // Reset bypassCache and reloadData on the $stateParams
                $stateParams.bypassCache = false;
                $stateParams.reloadData = false;
                $stateParams.reloadDataInBackground = false;

                promise
                .then(function onSuccess(response) {
                    if(response.direct_match) {
                        return $state.go('viewlisting', { listingId: response.direct_match.id, address: $filter('slug')(response.direct_match.address || '') });
                    }

                    response.listings = processListings(response.listings, getDetailViewParams);
                    var zipcodes = _.uniq(response.listings.map(function (listing) {
                        return listing.address.substr(-5);
                    }));
                    $mlsAcceptToC.checkZipCodes(zipcodes);

                    var pageData = {
                        offset_start: ((page - 1) * limit) + 1,
                        offset_end: ((page - 1) * limit) + response.listings.length,
                        page: page,
                        per_page: limit,
                        total: response.total,
                        total_pages: Math.ceil(response.total / limit),
                        data: response.listings,
                        orderby: vm.sortListBy.selected.value
                    };

                    currentObj._pageData = vm.model.pageData = pageData;

                    if(pageData && pageData.data && pageData.data.length) {
                        _.set(vm, 'data.paginatedResults', pageData.data);

                        updateUserCurrentState('page', pageData.page);
                        submitListhubTrackingData(vm.data.paginatedResults);
                        resetScrollTop();

                        vm.ui.exceptions.noResults = false;
                    } else{
                        vm.ui.exceptions.noResults = true;
                    }

                    vm.model.loadingListings = false;
                    vm.model.switchingFilters = false;
                })
                .catch(function (err) {
                    $log.error(err);
                    vm.model.loadingListings = false;
                    vm.model.switchingFilters = false;
                });
            }

            function switchCurrentView(viewName) {
                if(viewName && ['map', 'list'].indexOf(viewName) > -1) {
                    vm.currentView = viewName;
                    updateUserCurrentState('currentView', viewName);
                }
            }

            function mobileSortListByUpdated(title) {
                if(title) {
                    var found = _.findIndex(vm.sortListBy.options, {title: title});
                    if(!isNaN(found) && found > -1) {
                        vm.sortListBy.selected = vm.sortListBy.options[found];
                        vm.services.sortListByUpdated();
                    }
                }
            }

            function sortListByUpdated() {
                if(vm.sortListBy && vm.sortListBy.selected) {
                    resetPageData();
                    updateUserCurrentState('page', 1);
                    updateUserCurrentState('listViewScrollTop', 0);
                    updateUserCurrentState('sortListBy', vm.sortListBy.selected.value);
                    refreshSearchResults(vm.data);
                }
            }

            function updateFilterData(operation, keyword, name, params, filterId) {
                if(
                    !!filterId &&
                    ['edit', 'editname', 'delete'].indexOf(operation) > -1
                ) {
                    $user.getSearchFilter(filterId)
                        .then(function (response) {
                            var filter = response;
                            performFilterOperation(filter, operation, keyword, name, params);
                        })
                        .catch(function (err) {
                            $log.error('Error trying to find filter. ', err);
                        });
                } else {
                    var filter = new SearchFilter({ ownerId: $user.id });
                    performFilterOperation(filter, operation, keyword, name, params);
                }
            }

            function switchCurrentFilter(id) {
                vm.model.switchingFilters = true;
                toggleSearchPreloader(true);

                // if no id parameter is passed, and the user has at least 1 filter,
                // we set the user's default currentFilter as the first one found.
                var found = ($user.filters && $user.filters.length > 0) ? $user.filters[0] : null;

                var onFilterFound = function (filter) {
                    vm.model.listingsSource = 'filter';
                    updateResultSource('filter');
                    $user.currentFilter = filter;
                    $user.currentSearch = undefined;
                    resyncUserData();
                    refreshSearchResults(filter);
                    getPaginatedResults(1);
                };

                if(!!id) {
                    $user.getSearchFilter(id)
                    .then(function (response) {
                        toggleSearchPreloader(false);

                        if(!!response) { found = response; }

                        if(found) {
                            onFilterFound(found);
                        } else {
                            vm.ui.exceptions.noResults = true;
                        }
                    })
                    .catch(function (e) {
                        $log.error('Error trying to find filter. ', e);
                        toggleSearchPreloader(false);
                    });
                } else {
                    toggleSearchPreloader(false);

                    if(found) {
                        onFilterFound(found);
                    } else{
                        $log.debug('No filters found');

                        $user.currentFilter = undefined;
                        vm.model.switchingFilters = false;
                        vm.model.pageData = {};
                        updateNoFiltersFlag();
                    }
                }
            }

            function shouldShowSortByDomOption(opt) {
                return ((opt.title === 'Sort by Days on Market' && (vm.ui && vm.ui.showSortByDomOption)) ||
                    opt.title !== 'Sort by Days on Market');
            }

            function searchSubmit(keyword, latLng, noPageReset, source) {
                if(!source) source = 'search';
                vm.ui.resultSource = vm.model.listingsSource = 'search';

                if(!$user.currentSearch || $user.currentSearch && $user.currentSearch.search_term !== keyword) {
                    var search = new Search(keyword);
                    vm.usr.currentSearch = $user.currentSearch = search;
                    vm.usr.currentFilter = $user.currentFilter = undefined;
                    updateResultSource(source, noPageReset);
                    updateUserCurrentState('keyword', keyword);
                    getPaginatedResults(1);
                } else {
                    getPaginatedResults(_.get($user, 'currentSearch._pageData.page') || 1);
                }



                // updateResultSource(source, noPageReset);
                // updateUserCurrentState('keyword', keyword);
                // if(source !== 'map_search') {
                //     initMapConfig();
                // }

                // toggleSearchPreloader(true);

                // $search(keyword)
                // .then(function findResp(response) {
                //     $log.debug('Search Response: ', response);

                //     if(response) {
                //         updateResultSource(source, noPageReset);
                //         updateUserCurrentState('keyword', keyword);
                //         refreshSearchResults(response);
                //         if(source !== 'map_search') {
                //             initMapConfig();
                //         }
                //     }
                // })
                // .catch(function searchError(err) {
                //     $log.error(err);
                // })
                // .finally(function () {
                //     toggleSearchPreloader(false);
                // });
            }

            function getCurrentFilterId() {
                if(!(vm.ui.resultSource === 'filter' && vm.usr.currentFilter && vm.usr.currentFilter.id)) return undefined;

                return vm.usr.currentFilter.id;
            }


            // Functions
            function showFirstFilterModal() {
                if(localStorageService.get('userCreatedFirstFilter') != true){
                    if(vm.usr.account_type === 'guest' &&
                        angular.isArray(vm.usr.filters) &&
                        vm.usr.filters.length === 1){
                        if(!vm.usr.currentFilter) {
                            vm.usr.currentFilter = vm.usr.filters[0];
                        }

                        $firstFilterModal(vm.usr.currentFilter)
                            .then(function (response) {
                                if(response && response.length > 0) {
                                    vm.services.updateFilterData('editname', null, response, null, vm.usr.currentFilter.id);
                                }else{
                                    $log.debug('No response from first filter modal');
                                }
                            })
                            .catch(function (err) {
                                $log.error('Error updating filter name.', err);
                            })
                            .finally(function () {
                                $getAlertsModal();
                                localStorageService.set('userCreatedFirstFilter', true);
                            });
                    }
                }
            }

            function showAddToHomeScreenOverlay() {
                if(localStorageService.get('showedAddToHomeScreenOverlay') != true){
                    if( $utils.isIosSafari() ) {
                        if( !$utils.isStandalone() ) {
                            vm.ui.showAddToHomeScreenOverlay.ios = true;
                        }
                    } else if( $utils.isAndroid() ) {
                        vm.ui.showAddToHomeScreenOverlay.android = true;
                    }

                    localStorageService.set('showedAddToHomeScreenOverlay', true);
                }
            }

            function updateUserCurrentState(key, val) {
                var usrCurrState = localStorageService.get('userCurrentState');
                if(usrCurrState && key){
                    var updateObj = {};
                    updateObj[key] = val;
                    usrCurrState = _.extend({}, usrCurrState, updateObj);
                    localStorageService.set('userCurrentState', usrCurrState);
                    vm.usrCurrState = usrCurrState;
                    $log.debug('Updated userCurrentState in localStorage (usrCurrState, key, val):', usrCurrState, key, val);
                }else{
                    $log.debug('Couldn\'t update userCurrentState in localStorage (usrCurrState, key, val):', usrCurrState, key, val);
                }
            }

            function updateResultSource(src, noPageReset) {
                if(src && vm.ui) {
                    vm.ui.resultSource = src;
                    updateUserCurrentState('resultSource', src);

                    if(src !== 'filter') {
                        // we only reset the page data if there's a q search param in the current url
                        // or we had explicitly asked for a page reset (noPageReset === false)

                        if($stateParams.q || !noPageReset){
                            resetPageData();
                            updateUserCurrentState('page', 1);
                            updateUserCurrentState('listViewScrollTop', 0);
                        }
                    }else{
                        // we reset the page data if the new source is filter
                        // because this means the current filter was changed

                        resetPageData();
                        updateUserCurrentState('page', 1);
                        updateUserCurrentState('listViewScrollTop', 0);
                    }
                }
            }

            function initUserCurrentState() {
                var usrCurrState;
                if(!localStorageService.get('userCurrentState')){
                    $log.debug('Initializing localStorage userCurrentState');
                    usrCurrState = {
                        resultSource: 'filter',
                        page: 1,
                        sortListBy: ['-match_score', 'days_on_market', 'address'],
                        keyword: '',
                        currentView: 'list',
                        listViewScrollTop: 0
                    };
                    localStorageService.set('userCurrentState', usrCurrState);

                }else{
                    usrCurrState = localStorageService.get('userCurrentState');
                }

                return usrCurrState;
            }

            function initUserData() {
                vm.usr = JSON.parse(JSON.stringify($user || {}));
                vm.usrCurrState = initUserCurrentState();
                vm.ui = {
                    resultSource: vm.usrCurrState.resultSource,
                    exceptions: {
                        noResults: false,
                        noFilters: false
                    },
                    showAddToHomeScreenOverlay: {
                        ios: false,
                        android: false
                    },
                    showSortByDomOption: false
                };

                showFirstFilterModal();
                showAddToHomeScreenOverlay();
                updateNoFiltersFlag();
            }

            function initLayout(isMobile) {
                if(angular.isUndefined(isMobile)) {
                    isMobile = srUtils.isMobile();
                }
                var layout = (isMobile)
                    ? {
                        headerHeightOffset: '-56',
                        searchControlsHeight: '42',
                        mobileAlertsBannerHeight: '0',
                        listControlsHeight: '0'
                    }
                    :{
                        headerHeightOffset: '-56',
                        searchControlsHeight: '76',
                        mobileAlertsBannerHeight: (vm.usr && vm.usr.account_type === 'guest') ? '58' : '0',
                        listControlsHeight: '86'
                    };


                layout.listHeightOffset = srUtils.getListHeightOffset(layout);
                layout.windowHeight = function () {return $window.innerHeight;};
                vm.isMobile = isMobile;
                vm.layout = layout;
                vm.currentView = vm.usrCurrState.currentView || 'list';
            }

            function initMobileAlertsBanner() {
                vm.mab = {
                    phone: '',
                    open: function () {
                        if(vm.mab.phone){
                            $loginOrRegisterModal({phone: vm.mab.phone});
                        }
                    }
                };
            }

            function initPageData() {
                vm.model.pageData = {
                    page: vm.usrCurrState.page || 1
                };
            }

            function resetPageData() {
                vm.model.pageData = {
                    page: 1
                };
            }

            function resetScrollTop() {
                var scrollTopValue = 0;
                if(vm.usrCurrState && vm.usrCurrState.listViewScrollTop && !isNaN(vm.usrCurrState.listViewScrollTop)) {
                    scrollTopValue = parseInt(vm.usrCurrState.listViewScrollTop, 10);
                }
                $timeout(function () {
                    $('.list-container').scrollTop(scrollTopValue);
                }, 100);
            }

            function submitListhubTrackingData(listings) {
                var listingsColl = [];
                angular.forEach(listings, function (listing, i) {
                    if(listing && listing.id){
                        var decoded = simpleCypher.decode(listing.id);
                        if(decoded && decoded.id && decoded.source === 'listhub') {
                            this.push({'lkey': decoded.id});
                        }
                    }
                }, listingsColl);

                $listhub('submit', 'SEARCH_DISPLAY', listingsColl);
                $log.debug('Listing Keys Decoded Successfully!', listingsColl);
            }

            function uniqueAddressFilter(result) {
                var normalizedAddress = addressDeduplicationService.parseAndNormalizeAddress(result.address);
                return normalizedAddress;
            }

            function filterInvalidResults(results) {
                if(angular.isArray(results) && results.length > 0){
                    var r = results.filter(function (res) {
                            return (res.lat !== 0 && res.lon !== 0 && String(res.fake_scores) !== 'true');
                        });
                    $log.debug('Pre UNIQUE Count', r.length);
                    r = _.uniqBy(r, uniqueAddressFilter);
                    $log.debug('Post UNIQUE Count', r.length);
                }
                return r || [];
            }

            function sortResults(results, predicate) {
                if(angular.isArray(results) && results.length > 0){
                    var r = $filter('orderBy')(results, predicate);
                }
                return r || [];
            }

            function getDetailViewParams(listing, i) {
                var params = {
                    listingId: listing.id,
                    address: $filter('slug')(listing.address || '')
                };

                if( vm.ui &&
                    vm.ui.resultSource === 'filter' &&
                    vm.usr &&
                    vm.usr.currentFilter &&
                    vm.usr.currentFilter.id ){
                    params.filter = vm.usr.currentFilter.id;
                }

                if($location.search() && ($location.search().affiliate || $location.search().a)) {
                    params.affiliate = $location.search().affiliate || $location.search().a;
                }

                listing.detailViewParams = params;
            }

            function getHeroImages(listing, i) {
                listing.heroImage = srUtils.getHeroImageUrl(listing);
                listing.heroImageFallback = srUtils.getFallbackHeroImageUrl(listing);
            }

            function getNextOpenHouse(listing, i) {
                listing.next_open_house = srUtils.getNextOpenHouse(listing);
            }

            function getDaysOnMarket(listing, i) {
                listing.days_on_market = srUtils.getDaysOnMarket(listing);
            }

            function processListings(results, operation) {
                if(results && angular.isArray(results) && results.length > 0){
                    angular.forEach(results, operation, results);
                }

                return results;
            }

            function validateDaysOnMarketValues(results) {
                if(results && angular.isArray(results) && results.length){
                    var arr = results.filter(function (res, i) {
                        return String(res.days_on_market) !== 'null';
                    });

                    if(!arr.length) {
                        vm.ui.showSortByDomOption = false;
                        if(vm.sortListBy.selected &&
                            vm.sortListBy.selected.title == 'Sort by Days on Market'){
                            //reset selected option in the sort by dropdown
                            initListConfig();
                        }
                    }else{
                        vm.ui.showSortByDomOption = true;
                    }
                }
            }

            function keywordMatchEliminatedAllCheck(filterData) {
                vm.ui.exceptions.keywordMatchEliminatedAll = false;
                if(filterData && vm.ui.resultSource === 'filter') {
                    if(filterData.params) {
                        var keywordParam = _.find(filterData.params, {name: 'keywords'});
                        if( keywordParam &&
                            keywordParam.value &&
                            angular.isArray(keywordParam.value) &&
                            keywordParam.value.length > 0 ) {
                            vm.ui.exceptions.keywordMatchEliminatedAll = !filterData.results || (filterData.results && filterData.results.length === 0);
                        }
                    }
                }
            }

            function refreshSearchResults(o) {
                var data = JSON.parse(JSON.stringify(o || {}));

                if(data && !data.hasOwnProperty('error')){
                    vm.ui.exceptions.noResults = false;
                    // data.searchTerm = data.search_term || data.formatted_term;
                    // data.results = filterInvalidResults(data.results);
                    // data.results = processListings(data.results, getNextOpenHouse);
                    // data.results = processListings(data.results, getDaysOnMarket);
                    // validateDaysOnMarketValues(data.results);

                    // data.results = processListings(data.results, getDetailViewParams);
                    // Commented Out: This is actually causing the hero image to
                    // not show up and is not needed. The listing-card directive
                    // already handles checking for images and setting a fallback image.
                    // - LC 2017-01-13
                    // data.results = processListings(data.results, getHeroImages);
                    // data.results = sortResults(data.results, vm.sortListBy.selected.value);

                    vm.data = data;
                    updateUserCurrentState('keyword', data.search_term);
                    vm.services.getPaginatedResults(vm.model.pageData.page);
                }else{
                    vm.ui.exceptions.noResults = true;
                }

                keywordMatchEliminatedAllCheck(data);
            }

            function initCurrentFilterResults() {
                var data = (!!$user.currentFilter && !!$user.currentFilter.id)
                    ? JSON.parse(JSON.stringify($user.currentFilter))
                    : JSON.parse(JSON.stringify({}));

                refreshSearchResults(data);
            }

            function initMapConfig() {

                // default to Orange, CA
                var mapCenter = {
                    latitude: 33.810516,
                    longitude: -117.820227
                };
                var mapZoom = 11;


                if(_.has(vm, 'usrCurrState.resultSource') &&
                    vm.usrCurrState.resultSource === 'map_search' &&
                    vm.usrCurrState.mapCenter && vm.usrCurrState.mapZoom) {

                    mapCenter = vm.usrCurrState.mapCenter;
                    mapZoom = vm.usrCurrState.mapZoom;

                } else if(
                    vm.data &&
                    vm.data.paginatedResults &&
                    angular.isArray(vm.data.paginatedResults) &&
                    vm.data.paginatedResults.length > 0
                ){

                    mapCenter = srUtils.getMapCenter(vm.data.paginatedResults);
                    $log.debug('Getting center from results: ', mapCenter);
                }else{
                    $log.debug('Fallback to Orange, CA center');
                    vm.ui.exceptions.noResults = true;
                }


                vm.mapConfig = {
                    center: mapCenter,
                    zoom: mapZoom,
                    control: {},
                    windowOptions: {
                        boxClass: 'map-info-window-wrap',
                        maxWidth: 218,
                        pixelOffset: {
                            width: -109,
                            height: -228
                        }
                    }
                };
            }

            function initListConfig() {
                var sortListBy = srUtils.getListSortObj();
                if(
                    _.has(vm, 'usrCurrState.sortListBy') &&
                    sortListBy.selected &&
                    sortListBy.selected.value !== vm.usrCurrState.sortListBy
                ) {
                    // update SortListBy from user's current state
                    var obj = _.find(sortListBy.options, function (o) {
                        return o.value === vm.usrCurrState.sortListBy;
                    });

                    if(!!obj) {
                        sortListBy.selected = obj;
                        $log.debug('Updating sortListBy based on userCurrentState.', sortListBy);
                    }
                }

                vm.sortListBy = sortListBy;
            }

            function toggleSearchPreloader(f) {
                if(vm.ui) {
                    vm.ui.loadingSearch = (String(f) === 'true');
                }
            }

            function updateNoFiltersFlag() {
                vm.ui.exceptions.noFilters = (!$user.loadingFilters && _.has(vm, 'usr.filters') && vm.usr.filters.length === 0);
            }

            function resyncUserData() {
                vm.usr = angular.extend({}, vm.usr, $user);
                updateNoFiltersFlag();
            }

            function editFilterName(filter, name) {
                filter.name = name;
                filter.save()
                    .then(function (response){
                        resyncUserData();
                    })
                    .catch(function (err) {
                        $log.error('Error trying to edit filter name', err);
                    })
                    .finally(function () {
                        updateNoFiltersFlag();
                        toggleSearchPreloader(false);
                    });
            }

            function modifyFilterInstance(filter, operation, keyword, name, params) {
                if($user.currentFilter && filter.id === $user.currentFilter.id) {
                    $user.currentFilter._pageData = undefined;
                }

                filter.resetParams();
                filter.name = name;
                filter.search_term = keyword;

                if(params && angular.isArray(params) && params.length){
                    params.forEach(function (param) { filter.addFilter(param.name, param.value); });
                }

                filter.save()
                .then(function () {
                    if(operation !== 'edit') {
                        $user.addSearchFilter(filter, true);
                    }

                    resyncUserData();

                    if(vm.usr.currentFilter && filter.id === vm.usr.currentFilter.id){
                        vm.model.listingsSource = 'filter';
                        updateResultSource('filter');
                        refreshSearchResults(filter);
                    }
                })
                .catch(function saveFilterError(err) {
                    $log.error(err);
                })
                .finally(function () {
                    updateNoFiltersFlag();
                    toggleSearchPreloader(false);
                });
            }

            function deleteFilter(filter) {
                filter.delete()
                .then(function (response) {
                    $log.debug('Filter Deleted! ', $user);
                    resyncUserData();

                    // if trying to delete currentFilter, we will try and
                    // switch  $user.currentFilter to first the available filter or null
                    if(filter.id === vm.usr.currentFilter.id) {
                        vm.services.switchCurrentFilter();
                    }
                })
                .catch(function (err) {
                    $log.error('Error trying to delete filter. ', err);
                })
                .finally(function () {
                    toggleSearchPreloader(false);
                });
            }

            function performFilterOperation(filter, operation, keyword, name, params) {
                toggleSearchPreloader(true);

                if(operation) {
                    switch(operation) {
                        case 'editname':
                            editFilterName(filter, name);
                            break;

                        case 'delete':
                            deleteFilter(filter);
                            break;

                        case 'edit':
                        case 'new':
                        case 'duplicate':
                        default:
                            modifyFilterInstance(filter, operation, keyword, name, params);
                            break;
                    }
                }
            }

            function initSearchParamResults() {
                if($stateParams && $stateParams.q && $stateParams.q.length > 0) {
                    $timeout(function () {
                        vm.services.searchSubmit($stateParams.q, null, true);
                    }, 100);
                }
            }

            function initToolTip() {
                vm.toolTipMatchScoreClasses = [
                    {label:'great', value: '75+'},
                    {label: 'good', value: '51-74'},
                    {label: 'poor', value: '< 50'}
                ];
            }

            function loadCurrentFilterResults() {
                if(!$user.currentFilter){
                    vm.services.switchCurrentFilter();
                }
                initCurrentFilterResults();
            }


            // Init
            var init = function () {
                initUserData();
                initLayout();
                initPageData();
                initListConfig();
                initMobileAlertsBanner();
                initToolTip();

                if(!$stateParams.q){
                    if(vm.usrCurrState.resultSource !== 'filter' && vm.usrCurrState.keyword) {
                        $timeout(function () {
                            vm.services.searchSubmit(vm.usrCurrState.keyword, null, true, vm.usrCurrState.resultSource);
                        }, 100);
                    } else{
                        loadCurrentFilterResults();
                    }
                }else{
                    initSearchParamResults();
                }

                initMapConfig();
            };

            init();


            // EVENT HANDLERS
            var windowResizeHandler = function windowResizeHandler () {
                $timeout(function () {
                    var isMobileCheck = srUtils.isMobile();
                    if(vm.isMobile !== isMobileCheck) {
                        vm.isMobile = isMobileCheck;
                        initLayout(isMobileCheck);
                    }
                },0);
            };

            var debouncedResizeHandler = _.debounce(windowResizeHandler, 200);
            angular.element($window).on('resize', debouncedResizeHandler);

            var clearWindowResizeHandler = function () {
                angular.element($window).off('resize', debouncedResizeHandler);
            };


            $scope.$on('search-filters-loaded', function (ev) {
                $log.debug('On search-filters-loaded handler', ev);
                resyncUserData();

                // load current filter results on event only if:
                // - No q searchParam in the url
                // - No results exception is true
                // - usrCurrState.resultSource is 'filter'

                if(!$stateParams.q &&
                    ((_.has(vm, 'ui.exceptions.noResults') && vm.ui.exceptions.noResults == true) ||
                    !_.has(vm, 'ui.exceptions.noResults')) &&
                    ((_.has(vm, 'usrCurrState.resultSource') && vm.usrCurrState.resultSource === 'filter') ||
                    !_.has(vm, 'usrCurrState.resultSource'))

                ){
                    loadCurrentFilterResults();
                    initMapConfig();
                }
            });

            var clearScrollTopSaveHandler = $rootScope.$on('$stateChangeStart', function (ev, toState, toStateParams, fromState, fromStateParams) {
                var newScrollTop = $('.list-container').scrollTop();

                if(newScrollTop && !isNaN(newScrollTop)) {
                    updateUserCurrentState('listViewScrollTop', newScrollTop);
                }
            });

            $scope.$on('$destroy', function () {
                clearScrollTopSaveHandler();
                clearWindowResizeHandler();
            });

        }
    ],
    template: require('./index.html')
});
